import {
  EVENT_SET_SUBSCRIPTION_FIELDS,
  EVENT_SET_SUBSCRIPTION_SEEN_STATUS,
  EventSetSubscriptionFieldsPayload,
  EventSetSubscriptionSeenStatusPayload,
} from '@weblite/ts-action/subscription'
import { subscriptionsStorage } from './storage'
import { updateRoomLastMessage } from '$logic/room-last-message'
import { updateCachedUserPermissionsInRoom } from '$logic/user-permissions'
import { updateAdministeredChannelByChannelId } from '$logic/administered-channels'
import { serverSub } from '$func/subscription'
import { getSubscriptionFromStorage } from '$logic/subscription/client.service'

serverSub.subscribe(
  EVENT_SET_SUBSCRIPTION_SEEN_STATUS,
  async ({ patches }: EventSetSubscriptionSeenStatusPayload) => {
    patches.forEach(async ({ roomId, ...fields }) => {
      const subscription = await getSubscriptionFromStorage(roomId)
      if (subscription.seen < fields.seen)
        await subscriptionsStorage.set(roomId, fields)
    })
  },
)

serverSub.subscribe(
  EVENT_SET_SUBSCRIPTION_FIELDS,
  async (payload: EventSetSubscriptionFieldsPayload) => {
    await subscriptionsStorage.set(payload.roomId, payload.fields)

    if (!payload.fields) return

    if ('firstVisibleIid' in payload.fields)
      await updateRoomLastMessage(payload.roomId)

    if ('permissions' in payload.fields) {
      updateCachedUserPermissionsInRoom(payload.roomId)
      updateAdministeredChannelByChannelId(payload.roomId)
    }
  },
)
